import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import InputAdornment from "@material-ui/core/InputAdornment";
import TrashIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { Typography, FormLabel, Box } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { ShowHide } from "./ShowHide";

const useStyles = makeStyles(theme => ({
    container: {
        border: '1px solid',
        borderColor: theme.palette.text.hint,
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
        display: 'flex',
        flexFlow: 'wrap'
    },
    addButton: {
        marginLeft: 'auto'
    },
    title: {
        paddingTop: theme.spacing(1)
    },
    dynamicInputContainer: {
        marginTop: theme.spacing(1),
        width: '100%'
    },
    input: {
        margin: 0,
    }
}));


const MultiInputTextField = ({ initData = [], onDataChange = () => { }, disabled = false }) => {
    let [inputFields, setInputFields] = useState(initData);
    if (disabled) inputFields = initData;


    const classes = useStyles();

    const removeRow = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
        onDataChange(values)
    }

    const addRow = () => {
        const values = [...inputFields, ''];
        setInputFields(values);
    }

    const updateRow = (index, value) => {
        const values = [...inputFields];
        values[index] = value;
        setInputFields(values);
    }

    const onBlur = () => {
        const values = [...inputFields];
        setInputFields(values);
        onDataChange(values)
    }

    return (
        <Paper variant="outlined" elevation={0} className={classes.container}>
            <FormLabel className={classes.title}>First Time Use File Paths for Deletion</FormLabel>
            <ButtonGroup color="primary" className={classes.addButton}>
                <Button onClick={addRow} disabled={disabled}>+</Button>
            </ButtonGroup>
            <ShowHide show={inputFields.length > 0}>
                <Box className={classes.dynamicInputContainer} >
                    {inputFields.map((inputField, index) => (
                        <TextField
                            key={`FTUPath-${index}`}
                            onChange={(event) => updateRow(index, event.target.value)}
                            onBlur={onBlur}
                            margin="dense"
                            size="small"
                            placeholder="/path/to/file/or/directory/on/sdcard"
                            value={inputField}
                            fullWidth
                            InputProps={{
                                readOnly: disabled,
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        <IconButton disabled={disabled} onClick={() => removeRow(index)} >
                                            <TrashIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }} />
                    ))}
                </Box>
            </ShowHide>
        </Paper>
    );
};

export default MultiInputTextField;